module.exports = __webpack_public_path__ + "static/media/o.1b5a33cc.png";